<script lang="ts">
  import * as Popover from '$lib/components/ui/popover/index.js'
  import { Button } from '$lib/components/ui/button/index'
  import SlidersHorizontal from '@lucide/svelte/icons/sliders-horizontal'
  import LibraryHeaderBox from './LibraryHeaderBox.svelte'

  let {
    visibleTabsCount,
    closeAndFocusTrigger,
    handleSelection,
    genres,
    years,
    formats,
    tags,
    selectedGenres = $bindable([] as string[]),
    selectedStatus = $bindable([] as string[]),
    selectedYears = $bindable([] as string[]),
    selectedFormats = $bindable([] as string[]),
    selectedTags = $bindable([] as string[]),
  } = $props()
</script>

<div
  class="flex flex-col gap-0.5 rounded-md border border-latte-surface1/60 bg-latte-mantle/45 px-2.5 py-1.5 shadow-sm backdrop-blur-sm dark:border-macchiato-surface1/60 dark:bg-macchiato-mantle/45"
>
  <span class="text-[8px] leading-none font-light text-latte-surface1 dark:text-macchiato-surface1">
    filters
  </span>
  <Popover.Root>
    <Popover.Trigger>
      <Button
        size="icon"
        variant="ghost"
        class="h-8 w-8 text-latte-text/80 hover:bg-transparent hover:text-latte-mauve dark:text-macchiato-text/80 dark:hover:text-macchiato-mauve"
      >
        <SlidersHorizontal class="size-4" />
      </Button>
    </Popover.Trigger>
    <Popover.Content
      class="mr-6 w-[250px] space-y-3 border-latte-surface1/60 bg-latte-mantle dark:border-macchiato-surface1/60 dark:bg-macchiato-mantle"
    >
      <LibraryHeaderBox
        show={visibleTabsCount < 2}
        options={genres}
        optionKind="genre"
        bind:values={selectedGenres}
        {closeAndFocusTrigger}
        {handleSelection}
      />
      <LibraryHeaderBox
        show={visibleTabsCount < 3}
        options={['new', 'nsfw']}
        optionKind="status"
        bind:values={selectedStatus}
        {closeAndFocusTrigger}
        {handleSelection}
      />
      <LibraryHeaderBox
        show={visibleTabsCount < 4}
        options={years}
        optionKind="year"
        bind:values={selectedYears}
        {closeAndFocusTrigger}
        {handleSelection}
      />
      <LibraryHeaderBox
        show={visibleTabsCount < 5}
        options={formats}
        optionKind="format"
        bind:values={selectedFormats}
        {closeAndFocusTrigger}
        {handleSelection}
      />
      <LibraryHeaderBox
        show={visibleTabsCount < 6}
        options={tags}
        optionKind="tag"
        bind:values={selectedTags}
        {closeAndFocusTrigger}
        {handleSelection}
      />
    </Popover.Content>
  </Popover.Root>
</div>
